import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadWorkSegmentsPODD
export default function RWSPODDContent() {
    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { length, executorOrgName } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Протяжённость: {length} км</div>
            <div className="tooltip-info-row">Исполнитель: {executorOrgName ?? 'Не известен'}</div>
        </>
    )
}
